// DragOverlay.js
import { useDragLayer } from 'react-dnd';
import onlCamImg from "../../../images/onl-cam.svg";
import offlCamImg from "../../../images/offl-cam.svg";
import "../../../styles/siteplan.css";


const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 1000,
  left: 0,
  top: 0,
};

// Handles physical item dragging
const DragOverlay = () => {

  const { item, isDragging, currentOffset } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    isDragging: monitor.isDragging(),
    currentOffset: monitor.getClientOffset(),
  }))

  if (!isDragging || !currentOffset) { // don't render overlay if not dragging
    return null
  }

  return (
    <div
        style={{
            ...layerStyles,
            transform: `translate(${currentOffset.x}px, ${currentOffset.y}px)`, // position the image on cursor
        }}
        >
        <img src={item.camera_status === 1 ? onlCamImg : offlCamImg} alt="Offline camera" className="cam-image"></img>
    </div>
  )
}

export default DragOverlay
